<template>
  <div class="container-fluid ib-auth-bg">
    <loading class="register-overlay" v-show="showLoader" />

    <div class="row">
      <div class="col-md-4 offset-md-4 px-5">
        <div class="jbl-otp-h-right jbl-otp-right">

          <div class="text-center d-block my-5">
            <router-link :to="{ name: 'Home' }">
              <img alt="Logo Icon" class="img-fluid in-fluid-70" :src="require('@/assets/images/ib-logo.svg')" />
            </router-link>
          </div>

          <div class="jbl-otp-heading">
        <h5 class="ib-auth-desc" style="">We have sent you a code to verify your Phone Number <span>{{ currentUser.mobile_no }}</span><br> and Email <span>{{ currentUser.email }}</span></h5>
        </div>
        <form @submit.prevent="submitOtp" id="VerificationForm">
          <div>
            <div class="ib-input-field">
              <label class="jbl-label-sign">Email OTP</label>
              <input class="ib-login-input" type="text" id="exampleInputEmail1" placeholder="Email OTP" name="e_passcode" v-mask="'######'" required v-model="emailOTP"/>
            </div>
          </div>
          <div>
            <div class="ib-input-field">
              <label class="jbl-label-sign">Mobile OTP</label>
              <input class="ib-login-input" type="text" id="exampleInputPassword1" placeholder="Mobile OTP" name="m_passcode" v-mask="'######'" required v-model="mobileOTP"/>
            </div>
            <Timer class="ib-timer" :value="time" @timeout="timeOut()" v-if="showTimer"></Timer>
          </div>
          <div class="jbl-mx-auto">
            <button type="submit" class="ib-btn-primary ib-btn-hover ib-btn-width mt-4">Submit</button>
             <!-- type="button" -->
            <a @click="resendOTP()" class="ib-btn-primary ib-btn-hover ib-btn-width mt-4" v-if="showResend">Resend OTP</a>
             <!-- type="button" -->
            <a @click="updatePhoneNumber()" class="ib-link mt-4 pt-3" style="float:right;">Update Phone</a>
          </div>
        </form>
      </div>
      </div>
    </div>

    <div v-if="showUpdateMobileNumberModal">
      <transition name="modal fade">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
              <div class="modal-content">
                <div class="jbl-m-inner">
                  <div class="modal-header pb-0">
                    <h3 class="login-m-title">Update Mobile Number</h3>
                     <!-- data-dismiss="modal" aria-label="Close" -->
                    <span class="ib-m-close" @click="closeMobileNumberModal()">
                    &times;<!-- <img class="img-fluid" :src="require('@/assets/images/jbl-m-x-icon.png')" alt="icon"  @click="closeMobileNumberModal()" aria-hidden="true"> -->
                  </span>
                  </div>
                  <div class="modal-body">
                    <div>
                      <div class="jbl-field-sign">
                        <label class="jbl-label-sign">Mobile Number</label>
                        <input v-mask="'+92##########'" type="text" class="ib-login-input" v-model="newMobileNumber" @input="validateMobileNo($event)" placeholder="Enter Mobile Number"/>
                      </div>

                      <div v-if="errors.filter(x => x.field == 'newMobileNumber').length > 0">
                        <div class="d-block jbl-text-danger">
                          <small class="text-danger in-bottom-0">{{errors.filter(x => x.field == 'newMobileNumber')[0].message}}</small>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="modal-footer ib-m-footer">
                    <button class="ib-btn-primary ib-btn-hover mr-2" style="padding: 0.7125rem 1.5625rem !important; position: relative !important; top: 2px !important;" type="button" @click="updateMobileNumberPost()">Update</button>
                    <button type="button" class="ib-btn-outline ib-btn-hover" @click="closeMobileNumberModal()">Cancel</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
  import { mask } from "vue-the-mask";
  import loading from '@/components/Loading/Loading';
  import Timer from '@/components/Countdown/Timer';

  export default {
    name: 'OtpVerification',
    directives: { mask },
    components: {
      loading,
      Timer
    },
    data () {
      return {
        showLoader: false,
        showTimer: true,
        showResend: false,
        currentUser : this.$store.getters.getUser,
        emailOTP: '',
        mobileOTP: '',
        expiryDate: '',
        showUpdateMobileNumberModal: false,
        newMobileNumber: '',
        errors: [],
        time: 300
      }
    },
    created () {
      const self = this;
      if(self.$store.getters.isAuthenticated && self.$store.getters.isOTPVerified) {
        self.$router.push({ name: 'Home' });
      }
      if(!self.$store.getters.isAuthenticated) {
        self.$store.commit("resetState");
        window.location.reload();
      }
    },
    methods: {
      timeOut () {
        const self = this;
        self.showResend = true;
        self.showTimer = false;
      },
      async submitOtp () {
        var formData = new FormData(document.getElementById('VerificationForm'));
        const self = this;
        self.showLoader = true;
        await axios.post('customer/otp_verification', formData).then(function (response) {
          self.showLoader = false;
          if (response.data.code == 200) {
            if(response.data.data.user.chance_become_founder_member && response.data.data.user.is_founder_member == 0) {
              self.$store.commit('setSignupRedirect');
            }
            self.$store.commit('setOTPVerified');
            $toast.success('OTP Verified Successfully!!!', {position: 'top-right'});
            if (response.data.data.user.username_verified === 0) {
              self.$router.push({ name: 'UsernameVerification' });
            } else {
              window.location.reload();
            }
          }
        }).catch(function (error) {
          self.showLoader = false;
          $toast.error(error.response.data.message, {position: 'top-right'});
        });
      },
      async resendOTP () {
        const self = this;
        var formData = new FormData();
        formData.append('email', self.currentUser.email);

        self.showLoader = true;
        await axios.post('customer/generate_otp', formData).then(function (response) {
          self.showLoader = false;
          self.showResend = false;
          self.showTimer = true;
          if (response.data.code == 200) {
            self.emailOTP = '';
            self.mobileOTP = '';
            $toast.success('OTP Sent to your Mobile and Email', { position: 'top-right' });
          } else {
            $toast.error(response.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          $toast.error(error.response.data.message, {position: 'top-right'});
        });
      },
      validateMobileNo (event) {
        const self = this;
        let val = event.target.value;

        if(val != "") {
          const usingSplit = val.split('');
          let issue = false;

          let i = 0;
          for (i; i < 4; i++) {
            if(usingSplit[i] === '0') {
              issue = true;
              break;
            }
          }

          if (issue) {
            event.target.value = '+92';
            self.newMobileNumber = '+92';
          }
        }
      },
      updatePhoneNumber () {
        const self = this;
        self.errors = [];
        self.newMobileNumber = '';
        self.showUpdateMobileNumberModal = true;
      },
      async updateMobileNumberPost () {
        const self = this;
        self.errors = [];

        if(self.newMobileNumber.length < 13) {
          self.errors.push({
            field: 'newMobileNumber',
            message: 'Incorrect Mobile Number'
          });
        }

        if (self.errors.length > 0) {
          return false;
        }

        var formData = new FormData();
        formData.append('mobile_no', self.newMobileNumber);

        self.showTimer = false;
        self.showLoader = true;
        self.showUpdateMobileNumberModal = false;
        await axios.post('customer/change_mobile_no', formData).then(function (response) {
          self.showLoader = false;
          self.showTimer = true;
          if (response.data.code == 200) {
            self.currentUser.mobile_no = self.newMobileNumber;
            self.$store.commit('updateUserMobileNumber', self.newMobileNumber);
            self.closeMobileNumberModal();
            $toast.success('Mobile Number Updated Successfully!!', { position: 'top-right' });
          } else {
            $toast.error(response.data.message, { position: 'top-right' });
            self.showUpdateMobileNumberModal = true;
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          $toast.error(error.response.data.message, {position: 'top-right'});
          self.showUpdateMobileNumberModal = true;
        });
      },
      closeMobileNumberModal () {
        const self = this;
        self.errors = [];
        self.newMobileNumber = '';
        self.showUpdateMobileNumberModal = false;
      }
    }
  }
</script>

<style scoped>
  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, .5);
    display: table;
    transition: opacity .3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .container-fluid {
    background-repeat: no-repeat;
    height: 100%;
    position: fixed;
  }

  .jbl-sign-left h1 {
    font-size: 49px !important;
  }

  @media (max-width:850px) and (min-width: 750px) {
    .jbl-field.jbl-otp-field {
      margin-left: auto;
    }
  }

   @media (max-width:450px) {
    .jbl-otp-field {
      min-width: 300px !important;
    }

    .jbl-otp-right h5 {
      font-family: "Futura PT Medium";
      font-size: 25px;
      font-weight: 500;
      line-height: 1.28;
      color: #5b6770;
    }
  }

  @media (min-width:451px) {
    .jbl-otp-field {
      min-width: 380px !important;
    }
  }

  .modal-dialog-scrollable .modal-body {
    overflow-y: auto;
    overflow-x: hidden !important;
  }
  .jbl-otp-heading{
    max-width: 380px;
  }
  @media (max-width:1200px){
    .jbl-otp-heading{
      text-align: center !important;
      padding: .1rem;
    }
  }
  .jbl-otp-right h5 {
    font-family: "Futura PT Medium";
    font-size: 25px !important;
    font-weight: 500;
    line-height: 1.28;
    color: #5b6770;
}
@media(max-width:550px){
  .jbl-otp-right h5{
    font-size: 15px !important;
  }
  .in-fluid-70{
    max-width: 70% !important;
  }
}
@media(max-width:1200px){
  .ib-btn-width {
    max-width: 80px !important;
  }
  .ib-btn-primary {
      padding: 6px 9px !important;
  }
}
 div small.text-danger.in-bottom-0{
  position: relative;
  bottom: 0rem !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Auth/OtpVerification.vue